import { useMutation, useQuery } from '@tanstack/react-query';
import { EditIcon } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import { DialogDeleteRecordConfirmation } from '../../../../components/pages/backoffice/dialogs/delete-record.jsx';
import DecorativeInput from '../../../../components/decorative-input.jsx';
import Error from '../../../../components/feedback/error.jsx';
import Loading from '../../../../components/feedback/loading.jsx';
import Heading from '../../../../components/typography/heading.jsx';
import { Button } from '../../../../components/ui/button.jsx';
import FormCard from '../../../../components/ui/form-card.jsx';
import { msCatalystApi } from '../../../../services/api/ms-catalyst-api.js';
import { authState } from '../../../../services/state/auth-state.jsx';

export function EligibilityWatchlistShow() {
  const { isAdmin } = useSnapshot(authState);

  let { eligibilityWatchlistId } = useParams();

  const queryEligibilityWatchlist = useQuery({
    queryKey: ['eligibility-watchlist'],
    queryFn: async () => {
      const { data: eligibilityWatchlist } = await msCatalystApi.get(
        `eligibility-watchlist/${eligibilityWatchlistId}`,
      );

      return eligibilityWatchlist.data;
    },
  });

  const deleteEligibilityWatchlistMutation = useMutation({
    mutationFn: async () => {
      await msCatalystApi.delete(
        `/eligibility-watchlist/${eligibilityWatchlistId}`,
      );
    },
  });

  return queryEligibilityWatchlist.isLoading ? (
    <div className="flex h-[70dvh] items-center justify-center">
      <Loading />
    </div>
  ) : queryEligibilityWatchlist.isError ? (
    <Error />
  ) : (
    <>
      <div className="pb-6">
        <Heading className="pb-2">Colaborador(a)</Heading>
        <h2 className="text-lg text-zinc-600 dark:text-zinc-400">
          {queryEligibilityWatchlist.data.name}
        </h2>
      </div>

      <div className="flex flex-col space-y-10">
        <div className="flex flex-col gap-5">
          <FormCard>
            <DecorativeInput
              value={queryEligibilityWatchlist.data.name}
              label="Nome"
            />

            <DecorativeInput
              value={queryEligibilityWatchlist.data.identificationDoc}
              fieldLabel="Nº Identificação"
            />

            <DecorativeInput
              value={queryEligibilityWatchlist.data.shop}
              label="Loja"
            />
          </FormCard>
        </div>
      </div>

      <div className="flex flex-row flex-wrap justify-end gap-4 py-10">
        {isAdmin ? (
          <DialogDeleteRecordConfirmation
            recordName={queryEligibilityWatchlist.data.name}
            redirect="/backoffice/admin/eligibility-watchlist"
            action={async () =>
              deleteEligibilityWatchlistMutation.mutateAsync()
            }
          />
        ) : null}

        {isAdmin ? (
          <Link
            to={`/backoffice/admin/eligibility-watchlist/${eligibilityWatchlistId}/edit`}
          >
            <Button>
              <EditIcon />
              Editar
            </Button>
          </Link>
        ) : null}
      </div>
    </>
  );
}
